<div
    class="cmps-cdk-bg-color-white cmps-cdk-border-color-grey-300 cmps-cdk-border-solid cmps-cdk-border-width-1p"
>
    <div class="modal-header">
        <div
            class="modal-title h4"
            role="heading"
            aria-level="1"
        >
            {{ i18n._947_FORGOT_PASSWORD_OPTIONS | translate }}
        </div>
        <button
            type="button"
            class="close"
            [attr.aria-label]="i18n._763_CLOSE | translate"
            (click)="_dialogRef.close()"
        >
            <cmps-icon svgIcon="close"></cmps-icon>
        </button>
    </div>
    <div class="modal-body">
        <p>
            {{ i18n._948_PLEASE_SELECT_A_PASSWORD_RECOVERY_OPTION | translate }}
        </p>
        <div class="custom-control custom-radio">
            <input
                type="radio"
                class="custom-control-input"
                [id]="'recoveryOpt' + ResetOptions.EMAIL"
                name="recoveryOpt"
                [value]="ResetOptions.EMAIL"
                [(ngModel)]="opt"
            />
            <label
                class="custom-control-label"
                [for]="'recoveryOpt' + ResetOptions.EMAIL"
            >
                <span class="d-block">{{
                    i18n._939_EMAIL_RECOVERY | translate
                }}</span>
                <span>{{
                    i18n._949_USE_THIS_OPTION_TO_HAVE_YOUR_PASSWORD_EMAILED_TO_THE_EMAIL_ADDRESS_CONFIGURED_IN_COMPAS_
                        | translate
                }}</span>
            </label>
        </div>
        <div class="custom-control custom-radio">
            <input
                type="radio"
                class="custom-control-input"
                [id]="'recoveryOpt' + ResetOptions.QUESTION"
                name="recoveryOpt"
                [value]="ResetOptions.QUESTION"
                [(ngModel)]="opt"
            />
            <label
                class="custom-control-label"
                [for]="'recoveryOpt' + ResetOptions.QUESTION"
            >
                <span class="d-block">{{
                    i18n._942_CHALLENGE_RESPONSE | translate
                }}</span>
                <span>{{
                    i18n._950_USE_THIS_OPTION_TO_ANSWER_YOUR_SECRET_QUESTION_AND_RESET_YOUR_PASSWORD_
                        | translate
                }}</span>
            </label>
        </div>
        <hr *ngIf="opt !== ResetOptions.UNSET" />
        <ng-container [ngSwitch]="opt">
            <cmps-auth-reset-email
                *ngSwitchCase="ResetOptions.EMAIL"
            ></cmps-auth-reset-email>
            <cmps-auth-reset-question
                *ngSwitchCase="ResetOptions.QUESTION"
            ></cmps-auth-reset-question>
        </ng-container>
    </div>
    <div
        class="modal-footer"
        *ngIf="opt === ResetOptions.UNSET"
    >
        <button
            type="button"
            class="btn btn-primary"
            (click)="_dialogRef.close()"
        >
            {{ i18n._763_CLOSE | translate }}
        </button>
    </div>
</div>
